import createContext from '../context';
export default createContext({});